import { Badge } from '@/components/ui/badge'
import type { Note } from '@/types'

export interface ShareCardProps {
  note: Note
}

/**
 * 分享卡片组件
 * 用于导出分享图
 */
export function ShareCard({ note }: ShareCardProps) {
  const cover = note.images.find(img => img.url)?.url

  return (
    <div className="w-[900px] h-[500px] bg-gradient-to-r from-rose-50 via-white to-orange-50 p-8 rounded-3xl shadow-xl flex gap-6">
      <div className="w-[320px] h-full rounded-2xl overflow-hidden bg-white shadow-inner border">
        {cover ? (
          <img src={cover} alt="封面" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground">
            配图待生成
          </div>
        )}
      </div>
      <div className="flex-1 flex flex-col justify-between">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 to-orange-400" />
            <div>
              <div className="text-lg font-semibold">旋塔.AI</div>
              <div className="text-xs text-muted-foreground">
                灵感 · 口碑 · 转化
              </div>
            </div>
          </div>
          <h3 className="text-2xl font-bold leading-tight">{note.title}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed line-clamp-4 whitespace-pre-wrap">
            {note.content}
          </p>
          <div className="flex flex-wrap gap-2">
            {note.hashtags.map(tag => (
              <Badge key={tag} variant="secondary">
                #{tag}
              </Badge>
            ))}
          </div>
        </div>
        <div className="flex items-center justify-between pt-6 border-t">
          <div className="space-y-1 text-sm text-muted-foreground">
            <div>风格：{note.style}</div>
            <div>
              创建时间：{new Date(note.created_at).toLocaleString('zh-CN')}
            </div>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <span className="px-3 py-1 rounded-full bg-white border">
              小红书爆款灵感
            </span>
            <span className="px-3 py-1 rounded-full bg-white border">
              一键分享
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

